module.exports = __webpack_public_path__ + "static/media/shield-logo-blue.aab25813.png";